import { defineStore } from 'pinia'
import { getAuth, signOut, setPersistence, browserSessionPersistence, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        authReadyPromise: null
    }),
    actions: {
        async getUser () {
            const auth = getAuth()

            if (!this.authReadyPromise) {
                this.authReadyPromise = new Promise(resolve => {
                    const unsubscribe = onAuthStateChanged(auth, user => {
                        this.user = user || null
                        unsubscribe()
                        resolve(user)
                    })
                })
            }

            await this.authReadyPromise
        },
        async logIn (email, password){
            const auth = getAuth()

            try {
                await setPersistence(auth, browserSessionPersistence)
                const { user } = await signInWithEmailAndPassword(auth, email, password)

                this.user = user
                this.authReadyPromise = Promise.resolve(user)
            } catch (error) {
                console.log(error)
                throw error
            }
        },
        async logOut () {
            const auth = getAuth()

            await signOut(auth)

            this.user = null
            this.authReadyPromise = Promise.resolve(null)
        }
    }
})
